var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Indicator / Energy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Indicator-/-Energy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6703569,41.3069449 C23.890119,39.8691931 22,37.5137435 22,34.240596 C22,29.9940625 24.1658013,29.5181782 26.4028919,25.8370957 C27.0464706,24.7781014 27.806822,22.4990695 28.6839463,19 C34.7177736,23.0461791 38.0189232,27.0454872 38.5873951,30.9979244 C39.155867,34.9503617 37.5819088,38.2649532 33.8655206,40.9416991 C35.2603486,37.4174757 35.6891603,34.6638107 35.1519558,32.6807041 C34.6147513,30.6975975 33.1094869,28.8540223 30.6361626,27.1499786 C29.8290533,29.2654892 29.1345115,30.7086761 28.5525374,31.4795393 C27.0855713,33.4226328 25.7816103,35.0140798 25.5518119,36.1109989 C25.1732831,37.9178666 25.8794648,39.6498486 27.6703569,41.3069449 Z",
    id: "Path-3",
    fill: "#E3E2E2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/Energy.e630ddd8c5de66f14e2fcab35cb33b76.svg";
export { ForwardRef as ReactComponent };